import { useState } from "react";
import { MessageCircle, Mail, MapPin, Send } from "lucide-react";
import { Reveal } from "./Reveal";
import { CLINIC, whatsappLink } from "../data/site";

export const Contact = () => {
    const [nome, setNome] = useState("");
    const [telefono, setTelefono] = useState("");
    const [messaggio, setMessaggio] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        const text = `Ciao! Sono ${nome} (tel: ${telefono}). ${messaggio}`;
        window.open(whatsappLink(text), "_blank", "noopener,noreferrer");
    };

    const inputCls =
        "w-full bg-obsidian border border-white/15 rounded-xl px-5 py-4 text-white placeholder:text-white/30 focus:outline-none focus:border-gold transition-colors duration-300";

    return (
        <section id="contatti" data-testid="contact-section" className="py-24 sm:py-36 relative overflow-hidden">
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(212,175,55,0.09),transparent_55%)] pointer-events-none" />
            <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-24 relative">
                <div>
                    <Reveal>
                        <p className="text-xs uppercase tracking-[0.25em] text-gold/90 mb-4">
                            07 — Contatti
                        </p>
                        <h2
                            data-testid="contact-heading"
                            className="font-display text-5xl sm:text-6xl lg:text-7xl font-light tracking-tight text-white"
                        >
                            Inizia <span className="italic text-gold">ora.</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <p className="mt-8 text-white/70 leading-relaxed max-w-md">
                            Compila il modulo: si aprirà WhatsApp con il messaggio
                            già pronto. Allega la tua panoramica e ricevi il
                            preventivo gratuito entro 24 ore.
                        </p>
                    </Reveal>
                    <Reveal delay={0.15}>
                        <ul className="mt-10 space-y-5 text-white/70">
                            <li className="flex items-center gap-4">
                                <MessageCircle size={18} className="text-gold shrink-0" />
                                <span data-testid="contact-phone">WhatsApp · {CLINIC.phoneDisplay}</span>
                            </li>
                            <li className="flex items-center gap-4">
                                <Mail size={18} className="text-gold shrink-0" />
                                <a
                                    href={`mailto:${CLINIC.email}`}
                                    data-testid="contact-email-link"
                                    className="hover:text-gold transition-colors duration-300"
                                >
                                    {CLINIC.email}
                                </a>
                            </li>
                            <li className="flex items-center gap-4">
                                <MapPin size={18} className="text-gold shrink-0" />
                                <span data-testid="contact-location">{CLINIC.city}</span>
                            </li>
                        </ul>
                    </Reveal>
                </div>

                <Reveal delay={0.1}>
                    <form
                        onSubmit={handleSubmit}
                        data-testid="contact-form"
                        className="rounded-2xl border border-white/10 bg-charcoal p-7 sm:p-10 space-y-5"
                    >
                        <div>
                            <label htmlFor="nome" className="block text-xs uppercase tracking-[0.2em] text-white/50 mb-2">
                                Nome e cognome
                            </label>
                            <input
                                id="nome"
                                data-testid="contact-input-nome"
                                type="text"
                                required
                                value={nome}
                                onChange={(e) => setNome(e.target.value)}
                                placeholder="Mario Rossi"
                                className={inputCls}
                            />
                        </div>
                        <div>
                            <label htmlFor="telefono" className="block text-xs uppercase tracking-[0.2em] text-white/50 mb-2">
                                Telefono
                            </label>
                            <input
                                id="telefono"
                                data-testid="contact-input-telefono"
                                type="tel"
                                required
                                value={telefono}
                                onChange={(e) => setTelefono(e.target.value)}
                                placeholder="333 123 4567"
                                className={inputCls}
                            />
                        </div>
                        <div>
                            <label htmlFor="messaggio" className="block text-xs uppercase tracking-[0.2em] text-white/50 mb-2">
                                Messaggio
                            </label>
                            <textarea
                                id="messaggio"
                                data-testid="contact-input-messaggio"
                                rows={4}
                                value={messaggio}
                                onChange={(e) => setMessaggio(e.target.value)}
                                placeholder="Vorrei un preventivo per un impianto…"
                                className={`${inputCls} resize-none`}
                            />
                        </div>
                        <button
                            type="submit"
                            data-testid="contact-submit-button"
                            className="w-full inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full bg-wa text-black text-sm font-semibold uppercase tracking-[0.12em] hover:scale-[1.02] transition-transform duration-300"
                        >
                            <Send size={17} />
                            Invia su WhatsApp
                        </button>
                        <p className="text-xs text-white/40 leading-relaxed">
                            Inviando accetti di essere ricontattato via WhatsApp.
                            Nessun dato viene salvato su questo sito.
                        </p>
                    </form>
                </Reveal>
            </div>
        </section>
    );
};
